/**
 * Payment policy codes.
 *
 * A payment policy is classified by when the guest is expected to pay. These
 * are the only machine-readable codes the platform accepts for new policies.
 */
export const PAYMENT_POLICY_CODE = {
    FULL_UPFRONT_PAYMENT: 'FULL_UPFRONT_PAYMENT',
    PAY_ON_ARRIVAL: 'PAY_ON_ARRIVAL',
};
export const PAYMENT_POLICY_CODE_OPTIONS = [
    { value: PAYMENT_POLICY_CODE.FULL_UPFRONT_PAYMENT, label: 'Full upfront payment' },
    { value: PAYMENT_POLICY_CODE.PAY_ON_ARRIVAL, label: 'Pay on arrival' },
];
//# sourceMappingURL=payment-policy-codes.js.map